// 导入组件
import Vue from 'vue';
import Router from 'vue-router';

import login from '@/views/login';
import index from '@/views/index';

import iconDisplay from '@/views/iconfont/iconDisplay';
import MyPasswordEdit from '@/views/My/MyPasswordEdit';

import sysUser from '@/views/sysUser/sysUser';

import robot from '@/views/robot/robot';

import friend from '@/views/friend/friend';

import group from '@/views/friend/group';

import sysParam from '@/views/sysParam/sysParam';

import callbackRecord from '@/views/callbackRecord/callbackRecord';

// router enable
Vue.use(Router);

// export router
export default new Router({
    routes: [
        {path:'/', name:'', component:login, hidden:true, meta:{requireAuth:false}},
        {path:'/login', name:'登录', component:login, hidden:true, meta:{requireAuth:false}},
        {path:'/index', name:'首页', component:index, iconCls:'el-icon-tickets', children:[

            {path:'/MyPasswordEdit', name:'MyPasswordEdit', component:MyPasswordEdit, meta:{requireAuth:true}},

            {path:'/sysUser', name:'用户管理', component:sysUser, meta:{requireAuth:true}},

            {path:'/robot', name:'机器人', component:robot, meta:{requireAuth:true}},

            {path:'/friend', name:'微信好友', component:friend, meta:{requireAuth:true}},

            {path:'/group', name:'微信群', component:group, meta:{requireAuth:true}},

            {path:'/sysParam', name:'系统配置', component:sysParam, meta:{requireAuth:true}},

            {path:'/callbackRecord', name:'回调记录', component:callbackRecord, meta:{requireAuth:true}},

            {path:'/iconDisplay', name:'图标展示', component:iconDisplay, meta:{requireAuth:true}},
        ]}]
})



// WEBPACK FOOTER //
// ./src/router/index.js